/*
 * @Author: masonzhou
 * @Date: 2024-01-19 09:15:58
 * @LastEditTime: 2024-02-06 14:01:47
 * @FilePath: \yl-cjsph-tms-operation-front\src\utils\mixins.ts
 * @Description: 
 */
// 添加日期范围
export function addDateRange(params: any, dateRange: any, propName: any) {
  const search = params;
  search['params'] =
    typeof search.params === 'object' &&
    search.params !== null &&
    !Array.isArray(search.params)
      ? search.params
      : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof propName === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}

// 表单重置
export function resetForm(refName: any) {
  // @ts-ignore
  if (this.$refs[refName]) {
    // @ts-ignore
    this.$refs[refName].resetFields();
  }
}

// 表单清空校验
export function clearFormValidate(refName: any) {
  // @ts-ignore
  if (this.$refs[refName]) {
    // @ts-ignore
    this.$refs[refName].clearValidate();
  }
}
